// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KJ02","footer":"styles_footer__2Toj4","passCodeTooltip":"styles_passCodeTooltip__rP0C2"};